import React, { useState, useCallback } from 'react';
import { Box } from '@cko/primitives';
import { debounce } from '@cko/utils';
import styled from 'styled-components';
import useResizeObserver from '../../../hooks/useResizeObserver/useResizeObserver';
import PanelWrapper from './PanelWrapper';
const panelHeightClosed = '0';
const Panel = styled(Box) `
  position: relative;
  transition:
    height 0.2s ease-out,
    box-shadow 0.2s ease-out;
`;
const ButtonHeaderWrapper = styled.button `
  background-color: transparent;
  border: var(--border-b-sandgrain);
  cursor: pointer;
  margin: var(--layout-sandgrain) calc(-1 * var(--layout-soybean));
  padding: var(--layout-soybean);
  user-select: none;
  width: 100%;
`;
const DetailsWrapper = styled(Box) `
  & > div {
    transition:
      height 0.2s ease-out,
      opacity 0.1s ease-out;
  }
`;
/**
 * @deprecated - This component is made up of styled Box and Button components. You can either copy the component into your mfe or
 * recreate as appropriate.
 */
export const TimelinePanel = ({ children, header, 
// @deprecated - iconPair.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
iconPair, id, isOpen, setOpen, isFocused = false, }) => {
    const [contentHeight, setContentHeight] = useState(isFocused ? 'auto' : panelHeightClosed);
    const togglePanel = useCallback(() => {
        setOpen(!isOpen);
    }, [isOpen, setOpen]);
    const handleResize = debounce(({ height }) => {
        setContentHeight(`${height}px` || panelHeightClosed);
    }, 100);
    const { ref } = useResizeObserver({ onResize: handleResize });
    const panelHeight = isOpen ? contentHeight : panelHeightClosed;
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            const item = child;
            return React.cloneElement(item, { handleResize });
        }
        return child;
    });
    return (React.createElement(PanelWrapper, null,
        React.createElement(Panel, { width: "100%" },
            React.createElement(ButtonHeaderWrapper, { "aria-controls": id, "aria-expanded": isOpen, "data-testid": `button-${id}`, onClick: togglePanel }, header),
            React.createElement(DetailsWrapper, null,
                React.createElement(Box, { "aria-hidden": !isOpen, height: panelHeight, id: id, opacity: isOpen ? '1' : '0', overflow: "hidden" },
                    React.createElement("div", { ref: ref }, childrenWithProps))))));
};
